module.exports = __webpack_public_path__ + "c955f08c.svg";